module.exports = __webpack_public_path__ + "static/img/智能业财管理平台1.4d965fb8.png";